import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import i18n from 'i18n';
import getUsersISOLocale from '../i18n/getUsersISOLocale';
var defaultOptions = {
  weekday: 'short',
  month: 'long',
  day: 'numeric'
};
function getFallbackOptions(fallbackVariant) {
  switch (fallbackVariant) {
    case 'n-a':
      return i18n.t('not_applicable');
    case 'hyphen':
      return '-';
    case 'null':
    default:
      return null;
  }
}
function getLocalisedDate(_ref) {
  var date = _ref.date,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultOptions : _ref$options,
    _ref$fallbackVariant = _ref.fallbackVariant,
    fallbackVariant = _ref$fallbackVariant === void 0 ? 'null' : _ref$fallbackVariant,
    _ref$isInLocalTimezon = _ref.isInLocalTimezone,
    isInLocalTimezone = _ref$isInLocalTimezon === void 0 ? false : _ref$isInLocalTimezon;
  // If date is null or empty, handle fallback
  if (!date) {
    return getFallbackOptions(fallbackVariant);
  }
  var formattedDate = date;

  // If the input is already in local timezone, clean or pad it
  if (isInLocalTimezone) {
    if (formattedDate.indexOf('T') !== -1) {
      var _formattedDate$split = formattedDate.split('T'),
        _formattedDate$split2 = _slicedToArray(_formattedDate$split, 2),
        pureDate = _formattedDate$split2[0],
        time = _formattedDate$split2[1];
      formattedDate = "".concat(pureDate, "T").concat(time.split('.')[0]);
    } else {
      formattedDate = "".concat(formattedDate, "T00:00:00");
    }
  }
  var parsedDate = new Date(formattedDate);

  // Validate the date
  if (!isFinite(parsedDate.getTime())) {
    return getFallbackOptions(fallbackVariant);
  }

  // Safe to format
  return new Intl.DateTimeFormat(getUsersISOLocale(), options).format(parsedDate);
}
export default getLocalisedDate;